import dynamic from "next/dynamic";
import { withRouter } from "next/router";
import BayanApplication from "../../components/app/application/landing";
const LoginLayout = dynamic(() => import("../../hoc/appLayout"), {
  loading: () => <></>,
  ssr: true,
});
const Layout = dynamic(() => import("../../hoc/staticLayout"), {
  loading: () => <></>,
  ssr: true,
});
// const OpenSSRLayout = dynamic(() => import('../../hoc/openLayoutForSSR'), { loading: () => <></>, ssr: true });
import React, { useEffect, useState } from "react";
import Store from "../../store";

function Apply(props) {
  const { userAuth } = Store.getState();
  const [isLogin, setIsLogin] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    setFirstLoad(false);
    if (userAuth.authenticated && userAuth.token) {
      setIsLogin(true);
    }
  }, []);

  const meta = {
    title: "Graduate School Application | Bayan",
    description:
      "The Master of Arts (Religious Studies) in Islamic Studies is a two-year graduate program that focuses on the study of religious traditions, theology and ethics. Culminating with a Master’s Thesis, this program allows you to concentrate your studies in an area of interest. This is an appropriate degree if you are preparing for further study at the doctoral level; seeking advanced theological study as a foundation for service; or simply wish to study theology and religion without the aim of entering professional ministry.",
    route: "apply",
    image_url:
      "https://bayan.s3.us-west-2.amazonaws.com/static-content/bayan_apply.jpeg",
  };

  return (
    <>
      {
        // firstLoad ?
        // 	<OpenSSRLayout theme={props.theme} meta={meta}>
        // 		<BayanApplication router={props.router} />
        // 	</OpenSSRLayout> :
        isLogin ? (
          <LoginLayout theme={props.theme} meta={meta}>
            <BayanApplication router={props.router} />
          </LoginLayout>
        ) : (
          <Layout theme={props.theme} meta={meta}>
            <BayanApplication router={props.router} />
          </Layout>
        )
      }
    </>
  );
}

export default withRouter(Apply);
